import React from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useSelector } from "react-redux";

import { Box, Typography } from "@material-ui/core";
import JudgeTableHeading from "./JudgeTableHeading";
import JudgeTableItem from "./JudgeTableItem";

const JudgeTable = () => {
  const { hubbleJudges } = useSelector(({ hubble }) => hubble);
  return (
    <div className="Cmt-table-responsive">
      {hubbleJudges && hubbleJudges.length === 0 ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          paddingTop={"30px"}
          paddingBottom={"20px"}
        >
          <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
        </Box>
      ) : (
        <Table>
          <TableHead>
            <JudgeTableHeading />
          </TableHead>
          <TableBody>
            {hubbleJudges.map((item) => (
              <JudgeTableItem row={item} key={item._id} />
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default JudgeTable;
